import * as React from 'react';
import { Container } from '@grandvisionhq/elements';

const Layout = ({ children  })=>{
    return /*#__PURE__*/ React.createElement(Container, {
        className: "returns-layout"
    }, children);
};

export { Layout as default };
//# sourceMappingURL=Layout.js.map
